import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InventoryItemGroup } from 'src/app/models/results/inventory-item-group';
import { InventoryItemViewModel } from 'src/app/models/results/inventory-item-view-model';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UtilityService } from 'src/app/services/utility.service';
import { environment } from 'src/environments/non-vendor/environment';

@Component({
  selector: 'app-compare-results-card',
  templateUrl: './compare-results-card.component.html',
  styleUrls: ['./compare-results-card.component.scss']
})
export class CompareResultsCardComponent implements OnInit {
  @Input()
  deviceInfo!: InventoryItemGroup | null

  @Output() onRemoveItem: EventEmitter<any> = new EventEmitter();

  learnMoreButtonText: string = '';
  processorLabel: string = '';
  memoryLabel: string = '';
  storageLabel: string = '';
  displayLabel: string = '';
  showAddToCartButton: boolean = false;
  formQuantityError = '';
  subscriptionChoice: number = 0;
  showInStockInfo: boolean = false;

  constructor(public utilityService: UtilityService, private analytics: AnalyticsService, private confSvc: ConfigService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();
    this.learnMoreButtonText = this.confSvc.getString('deviceLearnMoreButtonText');
    this.processorLabel = this.confSvc.getString('deviceProcessorLabel');
    this.memoryLabel = this.confSvc.getString('deviceMemoryLabel');
    this.storageLabel = this.confSvc.getString('deviceStorageLabel');
    this.displayLabel = this.confSvc.getString('deviceDisplayLabel');
    this.showAddToCartButton = this.confSvc.getBool('showAddToCartButton');
    this.subscriptionChoice = this.confSvc.getNum("defaultSubscriptionCheck");
    this.showInStockInfo = this.confSvc.getBool("showInStockInfo");
  }

  onRemove(): void {
    this.onRemoveItem.emit(this.deviceInfo)
  }

  onLearnMore(): void {
    this.analytics.logLearnMoreClick(this.deviceInfo!.primaryItem);
    if (environment.name.includes('Insight')) {
      this.utilityService.openUrlInNewTab(
        this.deviceInfo?.primaryItem.vendorURL + '?cosds=chromeselector-click'
      );
    } else this.utilityService.openUrlInNewTab(this.deviceInfo!.primaryItem.vendorURL);
  }

  addToCartClick(device: InventoryItemViewModel, itemQuantity: string): void {
    const integerItemQuantity = parseInt(itemQuantity);
    if (integerItemQuantity > 99999 || integerItemQuantity < 1){
      this.formQuantityError = 'Quantity must be between 1 and 99999.';
    } else {
      this.formQuantityError = '';
      if (this.subscriptionChoice == 0 || this.subscriptionChoice == 1) {
        let addToCartData = {device: { skuNo: device.id, qty: integerItemQuantity }};
        console.log(addToCartData);
        window.parent.postMessage({ type: 'chrome-selector', event: addToCartData },'*');
      } else {
        let addToCartData = { device: { skuNo: device.id, qty: integerItemQuantity },license: { skuNo: this.subscriptionChoice.toString(), qty: integerItemQuantity }};
        console.log(addToCartData);
        window.parent.postMessage({ type: 'chrome-selector', event: addToCartData },'*');
      }
    }
  }

}
